export enum ModuleEnum {
    UserModule = 1,
    ChecklistModule = 2,
    BannerModule = 3,
    ResourceModule = 4,
    NotificationModule = 5,
    AdminModule = 6,
}
